<div class="container-fluid">
  @if (campaign && investmentInfo) {
    <div class="row">
      <div class="col-lg-12 d-flex py-5 title-panel border-bottom">
        <img
          [alt]="campaign.name"
          [src]="campaign.company?.companyLogoUrl || defaultLogo"
          class="campaign-logo"
        />
        <h2 class="font-weight-extrabold align-self-center mb-0">{{ campaign.name }}</h2>
      </div>
    </div>
    <div class="row py-5 invest-panel">
      <div class="col-lg-8 offset-lg-2">
        <h3 class="font-weight-extrabold">{{ (investmentInfo.enableShareBasedIncrement ? 'investment.howMuchInvest' : 'investment.investmentAmount') | translate }}</h3>
        <div class="mb-1">{{ 'investment.paymentsProcessedImmediately' | translate }}</div>
        <div class="mb-3 pb-2 mb-3">
          @if (!investmentInfo.enableShareBasedIncrement) {
            <div class="row text-black mb-2">
              <div class="col-lg-3 col-4">
                {{
                  campaign?.shareType === ShareType.Ulp
                    ? ('investment.numberUnit' | translate: { number: 1 })
                    : ('investment.numberShare' | translate: { number: 1 })
                }}:
              </div>
              <div class="col-lg-9 col-8 font-weight-bold">
                {{ investmentInfo.pricePerShare | numberSuffix }}
              </div>
            </div>
            <div class="row text-black mb-2">
              <div class="col-lg-3 col-4">
                {{ 'investment.numberLot' | translate: { number: 1 } }}:
              </div>
              <div class="col-lg-9 col-8 font-weight-bold">
                {{ investmentInfo.sharePerLot | number }}
                {{
                  campaign?.shareType === ShareType.Ulp
                    ? ('investment.units' | translate: { number: 1 })
                    : ('investment.shares' | translate)
                }}
              </div>
            </div>
            <div class="row text-black mb-2">
              <div class="col-lg-3 col-4">{{ 'investment.minLot' | translate }}:</div>
              <div class="col-lg-9 col-8 font-weight-bold">
                {{ investmentInfo.minimumLots | number }} {{ 'investment.lots_plural' | translate }}
              </div>
            </div>
            <div class="row text-black">
              <div class="col-lg-3 col-4">
                {{ 'investment.incrementalLot' | translate: { number: 1 } }}:
              </div>
              <div class="col-lg-9 col-8 font-weight-bold">
                {{ investmentInfo.incrementLot | number }}
                {{ 'investment.lots_plural' | translate }}
              </div>
            </div>
          }
        </div>
        <form [formGroup]="form" [class.show-form-error]="showFormError" (ngSubmit)="submit()">
          <app-investment-amount-picker
            [investmentInfo]="investmentInfo"
            (amountChange)="onAmountChange($event)"
          ></app-investment-amount-picker>
          @if (campaign.shareTypes?.length > 1) {
            <div class="input-panel">
              <div class="input-label">{{ 'investment.shareType' | translate }}</div>
              <section class="input-field">
                <mat-radio-group formControlName="shareType">
                  @for (shareType of campaign.shareTypes; track shareType) {
                    <mat-radio-button class="!tw-block tw-text-xl" [value]="shareType">
                      <div>
                        {{ 'offerCreation.' + ShareType[shareType] | translate }}
                      </div>
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </section>
              <app-validation-error-message
                [inputName]="'investment.shareType' | translate"
                [showFormError]="showFormError"
                [control]="form.get('shareType')"
              >
              </app-validation-error-message>
            </div>
          }
          <div class="input-panel">
            <label class="input-label" for="referralCode">{{
              'investment.referralCode' | translate
            }}</label>
            <div class="input-field">
              <input
                type="text"
                class="form-control input-normal full-width"
                [placeholder]="'investment.referralCodeOptional' | translate"
                formControlName="referralCode"
                [maxLength]="MaxReferalCodeLength"
                noSpace
                id="referralCode"
              />
            </div>
          </div>
          @if (slug === 'tupaiai') {
            <div>
              <h3 class="font-weight-extrabold mt-5 mb-3">
                {{ 'investment.PackageDetails' | translate }}
              </h3>
              <div class="tw-container">
                <img
                  src="assets/img/campaign/TUPAI_desktop.jpg"
                  alt="TUPAI_desktop"
                  class="w-full desktopimg"
                  width="100%"
                  height="100%"
                />
                <img
                  src="assets/img/campaign/TUPAI_mobile.jpg"
                  class="thumb mobileimg"
                  alt="TUPAI_mobile"
                  (click)="openImage()"
                  width="100%"
                  height="100%"
                />
                <!-- Fullscreen Modal -->
                @if (isOpen) {
                  <div class="modal" (click)="closeImage()">
                    <img
                      src="assets/img/campaign/TUPAI_mobile.jpg"
                      class="modal-img"
                      alt="TUPAI_mobile"
                    />
                  </div>
                }
              </div>
            </div>
          }
          <h3 class="font-weight-extrabold mt-5 mb-3">{{ 'investment.terms' | translate }}</h3>
          <div class="term-container full-width">
            <div class="checkbox-panel checkbox-field font-weight-bold d-flex">
              <mat-checkbox formControlName="isAcceptTerm1" class="checkbox">
                <div
                  class="align-top"
                  [innerHTML]="'investment.investmentTerms1' | translate"
                ></div>
              </mat-checkbox>
            </div>
            <div class="checkbox-panel checkbox-field font-weight-bold d-flex">
              <mat-checkbox formControlName="isAcceptTerm2" class="checkbox">
                <div
                  class="align-top"
                  [innerHTML]="'investment.investmentTerms2' | translate"
                ></div>
              </mat-checkbox>
            </div>
            @if (slug === 'sky-realm') {
              <div class="checkbox-panel checkbox-field font-weight-bold d-flex">
                <mat-checkbox formControlName="isHighRiskTerm1" class="checkbox">
                  <div
                    class="align-top"
                    [innerHTML]="
                      'investment.highRiskTerms1'
                        | translate
                          : {
                              CompanyName: campaign.company?.name,
                              Authority: 'Civil Aviation Authority of Malaysia (CAAM)',
                            }
                    "
                  ></div>
                </mat-checkbox>
              </div>
            }
            @if (slug === 'sky-realm') {
              <div class="checkbox-panel checkbox-field font-weight-bold d-flex">
                <mat-checkbox formControlName="isHighRiskTerm2" class="checkbox">
                  <div
                    class="align-top"
                    [innerHTML]="
                      'investment.highRiskTerms2'
                        | translate
                          : {
                              Authority: 'Civil Aviation Authority of Malaysia (CAAM)',
                            }
                    "
                  ></div>
                </mat-checkbox>
              </div>
            }
          </div>
            <div>
              <h3 class="font-weight-extrabold mt-5 mb-3">
                {{ 'common.disclaimer' | translate }}
              </h3>
            </div>
            <div class="terms-disclaimer">
              <p>{{ 'investment.issuerReservesTheRights' | translate }} {{ 'investment.investmentWillBeConfirmed' | translate }}</p>
            </div>
          <div class="input-panel mt-4">
            <button
              class="btn btn-primary mt-5 font-size-larger full-width"
              type="submit"
            >
              {{ 'investment.confirmInvest' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  @if (!campaign || !investmentInfo) {
    <agmo-loading></agmo-loading>
  }
</div>
